"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeCSS = exports.transform = exports.generateThemeColors = exports.baseThemeDefinition = void 0;
const transform_1 = __importDefault(require("./_generator/transform"));
/**
 * Exported runtime code
 */
var reshaped_1 = require("./_generator/definitions/reshaped");
Object.defineProperty(exports, "baseThemeDefinition", { enumerable: true, get: function () { return __importDefault(reshaped_1).default; } });
var generateColors_1 = require("./_generator/tokens/color/utilities/generateColors");
Object.defineProperty(exports, "generateThemeColors", { enumerable: true, get: function () { return __importDefault(generateColors_1).default; } });
var transform_2 = require("./_generator/transform");
Object.defineProperty(exports, "transform", { enumerable: true, get: function () { return __importDefault(transform_2).default; } });
const getThemeCSS = (name, definition, options) => {
    const code = (0, transform_1.default)(name, definition, { themeOptions: options, isFragment: true });
    return code.variables;
};
exports.getThemeCSS = getThemeCSS;
